// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import type { IconProps } from '@tls/treact-ui/icons';
import React from 'react';

const IconHide = ({ id, width, height, viewBox, strokeWidth, stroke, fill, ...other }: IconProps) => {
  return (
    <svg
      id={id ?? 'svg-hide'}
      data-name='svg-hide'
      data-testid='svg-hide'
      xmlns='http://www.w3.org/2000/svg'
      width={width ?? '2.25rem'}
      height={height ?? '2.25rem'}
      viewBox={viewBox ?? '0 0 36 36'}
      strokeWidth={strokeWidth ?? '0'}
      stroke={stroke ?? 'currentColor'}
      fill={fill ?? 'currentColor'}
      {...other}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M33 6.06244L31.5 4.56244L25.7644 10.298L22.8041 13.2583L21.2131 14.8494L14.8494 21.213L13.2584 22.8041L10.3273 25.7351L6 30.0624L7.5 31.5624L12.6514 26.411C14.3128 26.7916 16.1158 27 18 27C26.2843 27 33 22.9706 33 18C33 15.2914 31.0058 12.8622 27.8502 11.2123L33 6.06244ZM24.053 15.0094L22.3215 16.7409C22.4377 17.1405 22.5 17.563 22.5 18C22.5 20.4853 20.4853 22.5 18 22.5C17.563 22.5 17.1405 22.4377 16.741 22.3215L15.0094 24.053C15.9108 24.4992 16.9261 24.75 18 24.75C21.7279 24.75 24.75 21.7279 24.75 18C24.75 16.9261 24.4992 15.9108 24.053 15.0094ZM18 8.99999C19.9226 8.99999 21.7607 9.21702 23.45 9.61246L21.0736 11.9888C20.1518 11.5165 19.107 11.25 18 11.25C14.2721 11.25 11.25 14.2721 11.25 18C11.25 19.107 11.5165 20.1518 11.9888 21.0736L8.23205 24.8304C5.02893 23.1798 3 20.7321 3 18C3 13.0294 9.71573 8.99999 18 8.99999ZM18 13.5C18.4721 13.5 18.9273 13.5727 19.3549 13.7075L13.7076 19.3549C13.5727 18.9273 13.5 18.4721 13.5 18C13.5 15.5147 15.5147 13.5 18 13.5Z'
        fill={fill ?? 'currentColor'}
      />
    </svg>
  );
};

export default IconHide;
